import * as React from 'react';
import { Provider } from 'mobx-react';
import { configure } from 'mobx';
import { AppAdminStore } from './stores';
import { AppAdmin } from './AppAdmin';

export interface IAppAdminProps {
  token: string;
  environment: "Development" | "Test" | "Production";
  tenant: string;
  instanceName: string;
}

export class IAAppAdmin extends React.Component<IAppAdminProps> {

  private appAdminStore: AppAdminStore;

  constructor(props: IAppAdminProps) {
    super(props);
    this.appAdminStore = new AppAdminStore();
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
    this.updateStore(props);
  }

  public componentWillReceiveProps(props: IAppAdminProps) {
    this.updateStore(props);
  }

  private updateStore(props: IAppAdminProps): void {
    this.appAdminStore.token = props.token;
    this.appAdminStore.tenant = props.tenant;
    this.appAdminStore.environment = props.environment;
  }

  public render(): JSX.Element {
    return (
      <Provider appAdminStore={this.appAdminStore}>
        <AppAdmin
          instanceName={this.props.instanceName}
        />
      </Provider>
    );
  }
}